import { random, times } from 'lodash';

// Retourne {quantity} nombres de {length} chiffres
// TODO _ améliorer pour eviter les doublons
// TODO _ ajouter un test
export const getRandomNumbers = (quantity, length) =>
  times(quantity, () =>
    random(Math.pow(10, length - 1), Math.pow(10, length) - 1)
  );
